module.exports = __webpack_public_path__ + "static/media/formula_tab_ui.833e3f96.png";